<template>
    <div class="MyOrder1">
	  <el-tabs v-model="activeName" type="card" style="width: 70%;margin-left: 15%;margin-top: 20px" @tab-click="handleClick">
		<el-tab-pane label="我的报告"  name="first">
		   <MyAuthorize ref="myAuthorize" />
		</el-tab-pane>
		<el-tab-pane label="其他报告" name="second">
		  <OtherAuthorize ref="otherAuthorize" />
		</el-tab-pane>
	  </el-tabs>
    </div>
  
</template>

<script>

import MyAuthorize from "@/views/authorize/MyAuthorize";
import OtherAuthorize from "@/views/authorize/OtherAuthorize";
export default {
    name: 'MyReport',
    components: {
		MyAuthorize,
	    OtherAuthorize
    },
    data() {
        return {
		  activeName: 'first'
		}
    },
    methods: {}
}
</script>

<style scoped>
.MyOrder1 {
    border-top: 1px solid #989797;
    margin-top: 12px;
    overflow: hidden;
    margin-bottom: 200px;
}
.MyOrder1 .MyOrderBox {
    width: 1280px;
    margin: 0 auto;
}
.MyOrder1 .MyOrderBox .Img {
    margin-top: 60px;
    overflow: hidden;
    text-align: left;
    margin-bottom: 60px;
}
.MyOrder1 .MyOrderBox /deep/ .el-form--inline .el-form-item__label {
    font-weight: 600;
}
.MyOrder1 .MyOrderBox /deep/ .el-table .GoodsBox {
    overflow: hidden;
}
.MyOrder1 .MyOrderBox /deep/ .el-table .GoodsBox .image {
    width: 58px;
    height: 58px;
    float: left;
}
.MyOrder1 .MyOrderBox /deep/ .el-table .GoodsBox .image img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
}
.MyOrder1 .MyOrderBox /deep/ .el-table .GoodsBox .info {
    float: left;
    width: 292px;
    overflow: hidden;
    text-align: left;
    margin-left: 16px;
}
.MyOrder1 .MyOrderBox /deep/ .el-table .GoodsBox .info .title {
    font-weight: 600;
    margin-bottom: 10px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.MyOrder1 .MyOrderBox /deep/ .el-table .GoodsBox .info .desc {
    font-size: 12px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.MyOrder1 .MyOrderBox .page {
    text-align: right;
    margin-top: 20px;
}
.MyOrder1 .MyOrderBox .page  /deep/ .el-pagination.is-background .btn-next,
.MyOrder1 .MyOrderBox .page  /deep/ .el-pagination.is-background .btn-prev {
  padding: 0 5px;
}
</style>